import { createContext, useContext, type ReactNode } from "react";
import { useQuery } from "@tanstack/react-query";
import { DEFAULT_BRANDING, type Branding } from "@shared/branding";
import { api } from "./api";
import { queryKeys } from "./queryKeys";

export { DEFAULT_BRANDING, type Branding };

const BrandingContext = createContext<Branding>(DEFAULT_BRANDING);

export function BrandingProvider({ children }: { children: ReactNode }) {
  const { data } = useQuery({
    queryKey: queryKeys.branding(),
    queryFn: api.branding,
    staleTime: 5 * 60 * 1000,
    placeholderData: DEFAULT_BRANDING,
  });
  return (
    <BrandingContext.Provider value={data ?? DEFAULT_BRANDING}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding(): Branding {
  return useContext(BrandingContext);
}
